import { Fragment, useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import '../src/App.css';
import './css/global.css';
// import ScrollToTop from './components/otherComponents/ScrollToTop';

// Redux
import { Provider, useSelector } from 'react-redux';
import store from './store';
import Landing from './components/Landing';

// import setAuthToken from './utils/setAuthToken';
// import { loadUser } from './actions/auth';
// import Loader from './components/loader/Loader';
// import Alert from './components/layout/alert/Alert';

// import LandingPage from './components/landing/LandingPage';

const App = () => {
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   store.dispatch(loadUser());
  //   setLoading(false);
  // }, []);

  return (
    <Provider store={store}>
      <Router>
        <Fragment>
          {/* <Navbar></Navbar> */}
          <section className='pr-0 pl-0 bg-all'>
            {/* <Alert></Alert> */}
            <Routes>
              <Route exact path='/' element={<Landing />} />
            </Routes>
          </section>
        </Fragment>
      </Router>
    </Provider>
  );
};

export default App;
